import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { merge, Subscription } from 'rxjs';

import { IErrorForm } from '../../interfaces';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'app-control-errors',
  templateUrl: './control-errors.component.html',
  styleUrls: ['./control-errors.component.scss'],
})
export class ControlErrorsComponent implements OnChanges, OnDestroy {
  @Input() public control: UntypedFormControl | UntypedFormGroup;
  @Input() public controlClass: string = '';
  @Input() public errors: IErrorForm;
  @Input() public errorsOverrideParams: any;
  @Input() public helper: string = '';
  @Input() public isShowHelper: boolean = true;
  @Input() public isShowAlways: boolean = false;

  public preparedMessages: string[];

  private subscription: Subscription[] = [];

  constructor(private translateService: TranslateService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.control) {
      this.trackControlStatusChanges();
    }

    if (changes.errors || changes.errorsOverrideParams) {
      this.renderPreparedMessages();
    }
  }

  public ngOnDestroy(): void {
    this.subscription.forEach((s) => {
      s.unsubscribe();
    });
  }

  private trackControlStatusChanges() {
    if (this.control instanceof UntypedFormControl || this.control instanceof UntypedFormGroup) {
      this.subscription.forEach((s) => {
        s.unsubscribe();
      });
      this.subscription = [];
      this.subscription.push(
        merge(this.control.valueChanges, this.control.statusChanges).subscribe(() => {
          this.renderPreparedMessages();
        }),
      );
    }
    this.renderPreparedMessages();
  }

  private renderPreparedMessages(): void {
    this.getErrors();
  }

  private getErrors(): void {
    this.preparedMessages = [];
    if (!this.errors) {
      return;
    }
    Object.keys(this.errors).forEach((key) => {
      if (!this.control.hasError(key)) {
        return;
      }

      const value = this.errors.hasOwnProperty(key) ? this.errors[key] : null;

      if (!value) {
        return;
      }

      const translateParams =
        this.errorsOverrideParams && this.errorsOverrideParams[key]
          ? cloneDeep(this.errorsOverrideParams[key])
          : cloneDeep(this.control.getError(key));

      this.preparedMessages.push(this.translateService.instant(value, translateParams));
    });
  }
}
